import { ProductSnapshot } from './product-snapshot';

export class PurchaseOrderItem extends ProductSnapshot {}
